import { render, staticRenderFns } from "./ib-field-date-pick.vue?vue&type=template&id=7fd35c64&lang=pug&"
import script from "./ib-field-date-pick.vue?vue&type=script&lang=js&"
export * from "./ib-field-date-pick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd35c64')) {
      api.createRecord('7fd35c64', component.options)
    } else {
      api.reload('7fd35c64', component.options)
    }
    module.hot.accept("./ib-field-date-pick.vue?vue&type=template&id=7fd35c64&lang=pug&", function () {
      api.rerender('7fd35c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ib-field-date-pick.vue"
export default component.exports